import { QueryClient } from '@tanstack/react-query'

/** v2 API용 React Query 클라이언트 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5분간 캐시 유지
      staleTime: 5 * 60 * 1000,
      // 윈도우 포커스 시 자동 리페치 비활성화 (대시보드 특성상 불필요)
      refetchOnWindowFocus: false,
      // 실패 시 1회 재시도
      retry: 1,
    },
  },
})
